<br />

<div class="container">
  <h1>{{ session.config.title }}</h1>
  <h3>{{ session.config.one_liner }}</h3>
</div>

<div class="row container ideation-module-container">
  <div class="col-lg-8 description">
    <prosemirror-view
      [content]="session.config.descriptionRich"></prosemirror-view>
  </div>
  <div class="col-lg-4">
    <img alt width="100%" height="auto" [src]="thumbnailImage" />
  </div>
</div>
